<template>
  <div v-if="visible" class="py-2 px-4 text-base">
    <div class="relative rounded-md bg-red-50 p-4">
      <div class="flex h-24 overflow-scroll">
        <div class="flex-shrink-0">
          <icon set="solid" name="x-circle" class="h-5 w-5 text-red-400" />
        </div>
        <div class="ml-3 space-y-2">
          <h3 class="text-sm leading-5 font-medium text-red-800">
            {{ errorMessage }}
          </h3>
          <div class="text-sm leading-5 text-red-700">
            <ul class="list-disc pl-5 space-y-1">
              <li v-for="(error, index) in errors" :key="index">
                {{ error }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderError",
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
    errorMessage: {
      type: String,
      default: () => "Order Error",
    },
  },
  computed: {
    visible() {
      return this.errors?.length;
    },
  },
  watch: {},
  created() {},
  methods: {},
};
</script>
